import gql from "graphql-tag"

const DELETE_ADDRESSES_MODIFICATION = gql`
  mutation deleteOrderModificationAddresses($modificationId: ID!) {
    Order {
      deleteOrderModificationAddresses(modificationId: $modificationId) {
        status
      }
    }
  }
`

export default DELETE_ADDRESSES_MODIFICATION
